export const fieldsAnimationClass = 'animated zoomIn';

export const fieldsAnimationDelay = {
    animationDelay: '1.5s'
};




// WEBPACK FOOTER //
// ./src/Constants/animations.js